import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { KpiComponent } from "../../../../shared/components/kpi/kpi.component";
import { SysAdminHomeService } from "./facade/sys-admin-home.service";

@Component({
  standalone: true,
  selector: "app-admin",
  imports: [KpiComponent],
  templateUrl: "./admin.component.html",
  styleUrl: "./admin.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [SysAdminHomeService],
})
export class AdminComponent implements OnInit {
  public sysAdminFacade = inject(SysAdminHomeService);
  public ngOnInit() {
    this.sysAdminFacade.loadInitialState();
  }
}
